export const SEND_GIFT = 'SEND_GIFT'
export const GET_GIFT = 'GET_GIFT'
export const RECEIVE_GIFT = 'RECEIVE_GIFT'
export const CANCEL_GIFT = 'CANCEL_GIFT'
export const SEND_MAIL = 'SEND_MAIL'
export const IN_PROGRESS = 'IN_PROGRESS'



// WEBPACK FOOTER //
// ./src/store/MutationTypes.js